import { Component, OnInit } from '@angular/core';
import { NavbarInfoService } from '../../../home/services/navbar-info.service';

@Component({
  selector: 'app-login-main',
  templateUrl: './login-main.component.html',
  styleUrls: ['./login-main.component.sass']
})
export class LoginMainComponent implements OnInit {

  invalidCredentials: boolean;
  constructor(private info: NavbarInfoService) { }

  ngOnInit() {
  }

  receiveAuth(result) {
    if (result.name === 'HttpErrorResponse' && result.status === 400) {
      this.invalidCredentials = true;
    }
  }
  receiveClearMessage(result) {
    this.invalidCredentials = !result;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/components/login-main/login-main.component.ts